// Timecard stuff
export default {
  computed: {
  },

  methods: {
    shortenDate(date, refDate, tcDate) {
      if (!date || date === '') return '';

      // Handle timezone offset in milliseconds
      let msOffset = isNaN(this.tzoffset) ? 0 : parseInt(this.tzoffset * 60 * 1000);

      // Copy the date to perform some date math with the timezone offsets
      let fullDate = new Date(new Date(date) - msOffset);
      let fullRefDate = refDate ? new Date(new Date(refDate) - msOffset) : undefined;

      let hours = fullDate.getUTCHours();
      let minutes = fullDate.getUTCMinutes();

      // Display fixes to account for 36-hour clock
      const timeFromCall = fullRefDate ? fullDate.getUTCDate() - fullRefDate.getUTCDate() : 0; // If > 1, it's the next day
      if (timeFromCall > 0 || timeFromCall <= -27) hours = 24 + hours;
      // console.log({date, tzoffset: this.tzoffset, fullDate, fullRefDate, fullUtcDate: fullDate.getUTCDate(), fullRefDateUTC: fullRefDate ? fullRefDate.getUTCDate() : null, timeFromCall, HM: `${hours}:${minutes}`});

      // Failsafe, but this should not happen.
      if (hours < 0) hours = 24 + hours;
      if (minutes < 0) minutes = 60 + minutes;

      let shortTime = `${this.pad(hours)}:${this.pad(minutes)}`;
      return shortTime;
    },

    // pad 1-digit months/days
    pad(n) {
      return n < 10 ? '0' + n : n;
    },

    // Basic time checking to make sure time 2 > time 1, etc.
    verifyDay(target, checkAllTimes = false) {
      if (!target && !checkAllTimes) {
        return false;
      }

      // Reset Errors
      for (let i in this.timeErrors) {
        this.timeErrors[i] = false;
      };
      let error = ''; // messages if needed
      if (!checkAllTimes) {
        this.$emit('modified', true);
        if (this.day_type === 'nowork') this.day_type = 'worked';
        this.week[this.day].day_type = this.day_type;
      }
      this.updateTime(target);

      // Check if field pairs are complete
      if (this.time_2 && !this.time_1) {
        this.timeErrors.time_1 = true; error += ' Please enter a start time.';
      } else if (this.time_1 && !this.time_2) { this.timeErrors.time_2 = true; }

      if (this.time_3 && !this.time_4) {
        this.timeErrors.time_4 = true;
      } else if (this.time_4 && !this.time_3) { this.timeErrors.time_3 = true; error += ' Please enter a meal 1 beginning time.'; }
      else { this.timeErrors.time_3 = false; this.timeErrors.time_4 = false; }

      if (this.time_5 && !this.time_6) {
        this.timeErrors.time_6 = true;
      } else if (this.time_6 && !this.time_5) { this.timeErrors.time_5 = true; error += ' Please enter a meal 2 beginning time.'; }
      else { this.timeErrors.time_5 = false; this.timeErrors.time_6 = false; }

      if (this.time_5 && !this.time_3) {
        this.timeErrors.time_3 = true; error += ' Please enter a first meal before a second meal.';
      }

      // Now check if times are greater
      if (this.time_2 && this.time_1 && this.time_2 < this.time_1) {
        // this.timeErrors.time_1 = true;
        this.timeErrors.time_2 = true;
        error += ' Your wrap (out) time is earlier than your call (in) time.<br />Make sure to use military or "p" to designate evening hours, e.g. 6:30pm = 1830 or 630p.<br />If you worked overnight, you will have to add 24 hours to your call time, e.g. 5:30am would be 2930 (24 + 5:30).';
      }
      if (this.time_4 && this.time_3 && this.time_4 < this.time_3) {
        this.timeErrors.time_4 = true; error += ' Please make sure your 1st meal end is later than your meal start.';
      }
      if (this.time_6 && this.time_5 && this.time_6 < this.time_5) {
        this.timeErrors.time_6 = true; error += ' Please make sure your 2nd meal end is later than your meal start.';
      }

      // Check meal times are in the right sequence   
      if (this.time_4 && this.time_2 < this.time_4) {
        this.timeErrors.time_4 = true; error += ' Your meal should be earlier than your wrap (out) time.';
      }
      if (this.time_6 && this.time_2 < this.time_6) {
        this.timeErrors.time_6 = true; error += ' Your 2nd meal should be earlier than your wrap (out) time.';
      }
      if (this.time_3 && this.time_3 < this.time_1) {
        this.timeErrors.time_3 = true; error += ' Your meal should be later than your call (in) time.';
      }
      if (this.time_5 && this.time_5 < this.time_4) {
        this.timeErrors.time_5 = true; error += ' Your 2nd meal should be later than your 1st meal time.';
      }

      if (error && error.length) {
        this.$emit('error', error);
        return false;
      } else {
        this.$emit('error', ' ');
        return true;
      }
    },

    // Database stores times as strings. Convert to Date object
    convertWeekToDateObjects(timecardObject) {
      if (!timecardObject || typeof timecardObject !== 'object') {
        return;
      }

      for (let dayNum in timecardObject) {
        let dayObject = timecardObject[dayNum] || {};
        for (let time in dayObject) {
          if (!dayObject[time] || !time.match(/^time_/)) continue;
          // console.log(dayObject[time]);
          dayObject[time] = new Date(dayObject[time]);
          // console.log(dayObject[time]);
        }
      }

      return timecardObject;
    },

    // set/sync the time entered
    updateTime(target) {
      if (!target) {
        return false;
      }

      this[target.name] = target.value;
      if (typeof this.week !== 'undefined') this.week[this.day][target.name] = new Date(target.value);
      return true;
    },

    printTimecards(selected) {
      // console.log('PrintTimecards', typeof selected, selected);
      if (!selected) selected = this.selectedTimecards;
      if (typeof selected === 'function') selected = selected();
      if (!selected.length > 0) {
        this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to print', "buttonNo": false, "buttonYesLabel": "OK" });
        return false;
      }

      const useSpinner = typeof this.loading === 'undefined' ? false : true;
      if (useSpinner) this.loading = true;
      else this.waiting = true;

      let data = {
        "timecards": selected,
        "timezone_local": new Date().getTimezoneOffset()
      };

      this.oasisApi.post('/printTimecard', data)
        // .then(response => { this.employees = response; })
        .then(response => {
          // console.log (response);
          if (response.status == 200) {
            this.createDialog({ "title": "Success", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
          } else if (response.status == 400) {
            if (Array.isArray(response.data)) {
              let message = '';
              for (let i = 0; i < response.data.length; i++) {
                let error = JSON.parse(response.data[i]);
                $("input[name='" + error.field + "']").addClass('form-error2');
                message += error.message + "\n";
              }
              this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
            } else if (response.data.message) {
              this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
            } else {
              this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
            }
          } else {
            this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
          }
          if (useSpinner) this.loading = false;
          else this.waiting = false;
        })
        .catch(error => { console.log('error: '); console.log(error); this.waiting = false; });
    },

    reportTimecards(timecards) {
      if (typeof timecards === 'function') timecards = timecards();
      if (!timecards || (timecards.length === 0 && typeof timecards !== 'function')) {
        this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to report on.', "buttonNo": false, "buttonYesLabel": "OK" });
        return false;
      }

      let reportType = 'xlsx',
        json = {
          "report": {
            "report_title": "Timecard Report",
            "report_subtitle": null,
            "report_name": "timecard_report",
            "date_run": this.today(),
            "period": "All",
            "currency": "US",
            "date_start": "ALL",
            "date_end": "ALL",
            "data": []
          }
        };

      json.report.data = timecards;
      this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

      this.waiting = true;
      this.getJson(json)
        .then(response => {
          let report = this.reportServer + json.report.report_name + '.' + reportType + '?net.sf.jasperreports.json.source=' + response;
          let preview = this.reportServer + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
          // console.log(preview);
          this.getSpreadsheet(report)
            .then(reportUrl => {
              this.waiting = false;
              this.createDialog({ "title": "Success", "body": 'Please click to download your spreadsheet: <a href="' + reportUrl + '" target="_reports">Download Now</a>', "buttonNo": false, "buttonYesLabel": "OK" })
            })
            .catch(error => {
              console.log(error);
              this.waiting = false;
            })
            ;
        })
        .catch(error => {
          console.log(error);
          this.waiting = false;
        })
        ;
    },

    getSchedule(entityId = null, locationId = null, weekEnding = null) {
      const entity = entityId || this.entityId || this.entity.id;
      const location = locationId || this.locationId;
      const weekend = weekEnding || this.weekEnding;

      if (!entity || !location || !weekend) {
        return false;
      }

      // TODO multiple weeks, but union should be weekly
      const numDays = 6;
      let promises = [];
      let dates = [];
      const api = this.api || this.oasisApi;

      let date = new Date(weekend);

      for (let i = numDays; i >= 0; i--) {
        let tempDate = new Date(date);
        tempDate.setDate(tempDate.getDate() - i);
        const dayBefore = String(tempDate.getFullYear()) + String(this.pad(tempDate.getMonth() + 1)) + String(this.pad(tempDate.getDate()));

        let dateObject = {
          entity_id: entity,
          date: dayBefore,
          time_1: null, time_2: null, time_3: null, time_4: null, time_5: null, time_6: null,
          call_time: null, wrap_time: null, meal1_time_start: null, meal1_time_end: null, meal2_time_start: null, meal2_time_end: null,
          shooting_day: 0, project_location_id: location, grace: 0, wrap: 0, non_ded_breakfast: 0, french_hours: 0, french_hours_length: null
        };
        dates.push(dateObject);
        promises.push(api.get('/unionschedule/' + entity + '/' + location + '/' + dayBefore));

      }

      return Promise.all(promises)
        .then((responses) => {
          if (Array.isArray(responses)) {
            for (let i = 0; i < responses.length; i++) {
              if (responses[i].status === 200 && responses[i].data && Array.isArray(responses[i].data) && responses[i].data.length) {
                dates[i] = responses[i].data[0];
              }
            }
          }
          return dates;
        })
        .catch((error) => {
          console.log(error);
          return dates;
        });

    },

    refreshSchedule(entityId=null, locationId=null, weekEnding=null) {
      this.getSchedule(entityId, locationId, weekEnding)
        .then((response) => {
          this.dates = response;
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadProductionTimes() {
      this.getSchedule(this.assignment.entity_id, this.assignment.location_id, this.weekEnding)
        .then(response => {
          let counter = 0;
          for (const i in this.week) {
            if (i && !i.match(/^day_/)) continue;
            this.week[i].time_1 = response[counter].time_1 ? new Date(response[counter].time_1) : '';
            this.week[i].time_2 = response[counter].time_2 ? new Date(response[counter].time_2) : '';
            this.week[i].time_3 = response[counter].time_3 ? new Date(response[counter].time_3) : '';
            this.week[i].time_4 = response[counter].time_4 ? new Date(response[counter].time_4) : '';
            this.week[i].time_5 = response[counter].time_5 ? new Date(response[counter].time_5) : '';
            this.week[i].time_6 = response[counter].time_6 ? new Date(response[counter].time_6) : '';

            this.loadedTimes[i].time_2 = response[counter].time_2 ? (response[counter].time_2) : '';
            this.loadedTimes[i].time_3 = response[counter].time_3 ? (response[counter].time_3) : '';
            this.loadedTimes[i].time_4 = response[counter].time_4 ? (response[counter].time_4) : '';
            this.loadedTimes[i].time_5 = response[counter].time_5 ? (response[counter].time_5) : '';
            this.loadedTimes[i].time_6 = response[counter].time_6 ? (response[counter].time_6) : '';
            this.loadedTimes[i].time_1 = response[counter].time_1 ? (response[counter].time_1) : '';

            counter++;
          }
          this.lastUpdated = + new Date();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    emitError(message) {
        this.$emit('error', message);
    }
  },
}
